export const formatDisplayUrl = (url: string): string => url.replace(/\/+$/, '');
